/**
 * The `allowedCharsMode` preset → `regexPattern` map. Single source of truth
 * shared by the field editor (which writes the preset into `regexPattern` at
 * edit time) AND `deriveFieldValidations` (which falls back to the preset when
 * no explicit `regexPattern`/`inputMask` is set). `any` clears the pattern;
 * `custom` preserves whatever is already in `regexPattern` (so it has no preset
 * here). Keeping one table prevents the editor and the deriver from drifting.
 */
export const ALLOWED_CHARS_MODE_PRESETS = {
    letters: '^[a-zA-Z]*$',
    alphanumeric: '^[a-zA-Z0-9]*$',
    digits: '^[0-9]*$',
};
/**
 * Sentinel prefix that marks a mapping's `sourceField` as a static literal
 * value rather than a reference to a job-type field. The portion after the
 * colon is the literal text used in the export. (#54)
 */
export const LITERAL_SOURCE_PREFIX = '__literal:';
export function isLiteralSource(sourceField) {
    return sourceField.startsWith(LITERAL_SOURCE_PREFIX);
}
export function literalSourceValue(sourceField) {
    return sourceField.startsWith(LITERAL_SOURCE_PREFIX)
        ? sourceField.slice(LITERAL_SOURCE_PREFIX.length)
        : '';
}
//# sourceMappingURL=content.js.map